// extracted by mini-css-extract-plugin
export default {"formActions":"f71673c48b17"};